import { Endpoints } from "~constants/endpoints"
import { Api } from "~utils/api"
import { PERK_REDEMPTION_STATUS } from "~constants/status"

const RedemptionService = {
  getRedemptionsByUser: async (userId: string, { pageParam }) => {
    const url = `${Endpoints.PERK_REDEMPTIONS.URL}?size=15&page=${pageParam}&sort=CreatedAt,DESC&userId=${userId}`
    try {
      const response = await Api.get(url)
      return {
        result: response.data.data,
        hasNextPage: response.data.hasNext ? pageParam + 1 : false,
      }
    } catch (error) {
      return Promise.reject(error)
    }
  },
  redeemPerk: async (perkId: string, payload: any) => {
    const url = Endpoints.REDEEM.URL.replace(":perkId", perkId)
    return await Api.post(url, payload)
  },
  patchRedemption: async (payload: {
    invalidationReason: string | null
    amount: string | null
    redemptionId: string
    currency: string | null
    invalidationDetails: string | null
    status: PERK_REDEMPTION_STATUS
  }) => {
    const url = Endpoints.PERK_REDEMPTION.URL.replace(
      ":redemptionId",
      payload.redemptionId
    )
    const data = {
      redemptionStatus: payload.status,
      ...(payload.invalidationReason !== null && {
        invalidationReason: payload.invalidationReason,
      }),
      ...(payload.invalidationReason !== null && {
        invalidationDetails: payload.invalidationDetails || null,
      }),
      ...(payload.currency !== null && {
        cclOnboardCreditCurrency: payload.currency,
      }),
      ...(payload.amount !== null && {
        cclOnboardCreditValue: payload.amount,
      }),
    }
    return await Api.patch(url, data)
  },
  getFlow: async (perkCode: string): Promise<any> => {
    try {
      const flowUrl = Endpoints.PERK_REDEMPTION_FLOW.URL.replace(
        ":perkCode",
        perkCode
      )
      const response = await Api.get(flowUrl)
      return response.data
    } catch (error) {
      return Promise.reject(error)
    }
  },
}

export default RedemptionService
